export enum ServiceContractPositionKind {
  UEBERNEHMEN_MIT_WARTUNGSSUMME = 'UEBERNEHMEN_MIT_WARTUNGSSUMME',
  UEBERNEHMEN_MIT_E_PREIS_AUS_WARTUNGS_OBJEKT = 'UEBERNEHMEN_MIT_E_PREIS_AUS_WARTUNGS_OBJEKT',
  UEBERNEHMEN_OHNE_PREIS = 'UEBERNEHMEN_OHNE_PREIS',
  UEBERNEHMEN_MIT_ARTIKELPREIS = 'UEBERNEHMEN_MIT_ARTIKELPREIS',
  UEBERSCHRIFT = 'UEBERSCHRIFT',
  TEXTZEILE = 'TEXTZEILE',
  NICHT_UEBERNEHMEN = 'NICHT_UEBERNEHMEN',
}
